/**
 * Standard Shopify Predictive Search Function
 * Fetches predictive search results and appends them to instant-search-results__wrapper
 */

(function() {
  'use strict';

  // Debounce helper function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * Initialize predictive search functionality
   */
  function initPredictiveSearch() {
    // Check if routes are available
    if (!window.routes || !window.routes.predictive_search_url) {
      console.warn('Predictive search: routes not available');
      return;
    }

    // Find the search input
    const searchInput = document.querySelector('[js-search-input="input"]');
    const resultsWrapper = document.querySelector('.instant-search-results__wrapper');
    const suggestionElements = document.querySelectorAll('[data-suggestions]');
    
    if (!searchInput || !resultsWrapper) {
      return;
    }

    let abortController = null;

    /**
     * Fetch predictive search results from Shopify
     * @param {string} query - Search query
     */
    function fetchPredictiveSearch(query) {
      // Cancel any pending requests
      if (abortController) {
        abortController.abort();
      }

      // Create new abort controller for this request
      abortController = new AbortController();

      // Build the predictive search URL
      const searchParams = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'section_id': 'predictive-search'
      });

      const url = `${window.routes.predictive_search_url}?${searchParams.toString()}`;

      // Fetch the predictive search section
      fetch(url, {
        signal: abortController.signal,
        headers: {
          'Accept': 'text/html',
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(html => {
          // Parse the HTML response
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Find the predictive search section content
          const predictiveSearchSection = doc.querySelector('#shopify-section-predictive-search');
          
          if (predictiveSearchSection) {
            // Extract the inner HTML from the predictive search section
            const searchResultsHTML = predictiveSearchSection.innerHTML;
            
            // Append the results to the wrapper
            resultsWrapper.innerHTML = searchResultsHTML;
            
            // Hide suggestion elements when results are rendered
            suggestionElements.forEach(element => {
              element.style.display = 'none';
            });
          }
        })
        .catch(error => {
          if (error.name === 'AbortError') {
            // Request was aborted, ignore
            return;
          }
          console.error('Predictive search error:', error);
        });
    }

    /**
     * Handle input changes
     */
    const handleInput = debounce(function(event) {
      const query = event.target.value.trim();
      
      if (query.length >= 2) {
        fetchPredictiveSearch(query);
      } else {
        // Clear results if query is too short
        resultsWrapper.innerHTML = '';
        
        // Show suggestion elements again when input is cleared
        suggestionElements.forEach(element => {
          element.style.display = '';
        });
      }
    }, 300);

    // Add event listener to the search input
    searchInput.addEventListener('input', handleInput);

    // Optional: Handle focus to show results if query exists
    searchInput.addEventListener('focus', function() {
      const query = searchInput.value.trim();
      if (query.length >= 2) {
        fetchPredictiveSearch(query);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
  } else {
    initPredictiveSearch();
  }

})();

